










import { defineComponent } from "@vue/composition-api";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "SubscriberIcon",
  components: { FormatMoney },
  props: {
    cost: { type: Number, required: true },
  },
});
